import axios from "axios";
import Config from "src/config";

// PSIDs de conversas recentes — o envio de utility message exige um PSID, que só
// existe depois de o usuário ter falado com a Página.
const v1_actionMessengerDestinatarios = (clienteId, params = {}) => {
    const query = new URLSearchParams();
    if (params.canalId) query.set('canalId', params.canalId);

    const queryString = query.toString() ? `?${query.toString()}` : '';

    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/destinatarios${queryString}`
    });
};

export default v1_actionMessengerDestinatarios;
